import React from 'react';
import { useSelector } from 'react-redux';

import styles from './Address.module.scss';

import HelpBox from '../../components/HelpBox/HelpBox';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import ProgressButtons from '../../components/Progress/ProgressButtons/ProgressButtons';
import ProgressBar from '../../components/Progress/ProgressBar/ProgressBar';
import {
  getPrimaryAddress,
  isClientRMD,
} from '../../redux/modules/PersonalInformation/personalInformation.selectors';
import {
  ADDRESS_STEP,
  DISTRIBUTION_METHOD_STEP,
  TOLL_FREE_NUMBER,
  DESTINATION_STEP,
} from '../../settings/settings';
import RMLConnection from '../../components/RMLConnection/RMLConnection';
import {
  getTraditionalIraAddresses,
  getRollOverIraAddresses,
} from '../../redux/modules/UserFunds/userFunds.selectors';
import RMDAddresses from './RMDAddresses'

export const uniqueAddressExtractor = (addressArray) => {
  let map = new Map();
  let uniqueAdd = [];
  addressArray &&
    addressArray.forEach((address) => {
      const addressWithoutType = { ...address };
      addressWithoutType.serviceId = address.serviceId
        ? address.serviceId
        : false;
      if (addressWithoutType.name) {
        delete addressWithoutType.address.type;
        delete addressWithoutType.address.effectiveDate;
      } else {
        delete addressWithoutType.type;
        delete addressWithoutType.effectiveDate;
      }
      if (!map.has(JSON.stringify(addressWithoutType))) {
        map.set(JSON.stringify(addressWithoutType), true);
        uniqueAdd.push(address);
      }
    });

  return uniqueAdd;
};

const Address = (props) => {
  const RMDClient = useSelector(isClientRMD);
  const primaryAddress = useSelector(getPrimaryAddress);
  let traditionalIraAddresses = useSelector(getTraditionalIraAddresses);
  let rolloverIraAddresses = useSelector(getRollOverIraAddresses);
  const uniqueTraditionalAddress = uniqueAddressExtractor(
    traditionalIraAddresses
  );
  let uniqueRolloverAddress = uniqueAddressExtractor(rolloverIraAddresses);
  let combinedAddress = uniqueTraditionalAddress.concat(uniqueRolloverAddress);
  const combinedUniqueAddress = uniqueAddressExtractor(combinedAddress);

  return (
    <div className="rmd-distribution-wrapper">
      <div className="sticky-header">
        <div className="heading">Auto-RMD Setup</div>
        <ProgressButtons
            nextStep={DISTRIBUTION_METHOD_STEP}
            previousStep={DESTINATION_STEP}
            {...props}
            showBackButton={true}
            backDisabled={false}
            edit={props.edit}
        >
          <ProgressBar />
        </ProgressButtons>
      </div>
      <PageWrapper step={ADDRESS_STEP}>
        <div className="scroll-wrapper">
          <div className="rmd-title">
            {combinedUniqueAddress.length > 1 ? (
              <span>
                We have multiple addresses{' '}
                <span className="orphan-line"> on file.</span>
              </span>
            ) : (
              <span>
                Here is the address we have{' '}
                <span className="orphan-line"> on file:</span>
              </span>
            )}
          </div>
          <div className={styles['option-container']}>
            <RMDAddresses
              combinedUniqueAddress={combinedUniqueAddress}
              uniqueRolloverAddress={uniqueRolloverAddress}
              uniqueTraditionalAddress={uniqueTraditionalAddress}
              RMDClient={RMDClient}
              primaryAddress={primaryAddress}
            />
            <HelpBox step={ADDRESS_STEP} />
            <RMLConnection phoneNumber={TOLL_FREE_NUMBER} />
          </div>
        </div>
      </PageWrapper>
    </div>
  );
};

export default Address;
